/**
 * Echelon CAPTCHA Fix
 * Patches the contact and newsletter form submission handlers to use Shopify CAPTCHA
 * This file is loaded AFTER echelon-app.js to ensure the forms are patched at runtime
 */
(function() {
  'use strict';

  function patchForm(form) {
    if (!form || form.getAttribute('data-captcha-patched')) return;
    form.setAttribute('data-shopify-captcha', 'true');
    form.setAttribute('data-captcha-patched', 'true');
  }

  function patchAllForms() {
    patchForm(document.getElementById('ContactForm'));
    patchForm(document.getElementById('NewsletterCaptchaForm'));
  }

  // Run on DOM ready and after React renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(patchAllForms, 200);
    });
  } else {
    setTimeout(patchAllForms, 200);
  }

  // Also watch for dynamically added forms (newsletter popup appears after 4s)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function() {
      patchAllForms();
    });
    document.addEventListener('DOMContentLoaded', function() {
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      }
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
